import React, { useEffect } from 'react';
import { useState } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import SearchBar from './topSubMenuComponents/SearchBar.js';
import GenPDF from './topSubMenuComponents/genpdf.js'

const TopSubMenu = ({
    mapboxTokenRef,
    globalState,
    globalRefs,
    isInAboutPanel,
    isInInvestorsPanel,
    isInPrivacyPanel,
    isInTacPanel,
    resetAboutPanels,
    isInSettings,
}) => {


    let selectedMetric = globalState.selectedMetric;
    let longstandingGeoJSONRef = globalRefs.longstandingGeoJSONRef;
    let selectedYearEditing = globalState.selectedYearEditing;
    let setFeatureList = globalState.setFeatureList;
    let setActiveFeatureId = globalState.setActiveFeatureId;
    let multuGroupSelectedArray = globalState.multuGroupSelectedArray;
    let polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;
    let setIsRealmLeftClickedInfoVisible = globalState.setIsRealmLeftClickedInfoVisible;
    let setClickedInfoTab = globalState.setClickedInfoTab;
    let setisMenuLoadClick = globalState.setisMenuLoadClick;

    // Loading state
    let isLoading = globalState.isLoading;

    const backToMap = () => {
        resetAboutPanels();
    }

    let totalSum = 0;

    useEffect(() => {
    }, [selectedMetric, longstandingGeoJSONRef.current, selectedYearEditing]);

    let noData = true;

    if (!longstandingGeoJSONRef.current) {
        noData = true;
    } else {
        noData = false;
    }

    const closeClickedInfoRealm = () => {
        setClickedInfoTab("DATA");

        if (Array.isArray(multuGroupSelectedArray)) {
            multuGroupSelectedArray.forEach(skylarkId => {
                polygonCustomLayerRef.current
                    .removedSkylarkIdFromsetMultuGroupSelectedArrayPoints(skylarkId);
            });
        }

        setIsRealmLeftClickedInfoVisible(false);
        setFeatureList([]);
        setActiveFeatureId(null);
    };

    return (
        <div
            className={`top_Submenu ${isInAboutPanel ||
                    isInInvestorsPanel ||
                    isInPrivacyPanel ||
                    isInTacPanel ||
                    isInSettings
                    ? 'inabout'
                    : ''
                } ${isLoading ? 'top_Submenu_loading' : ''}`}
        >

            <BrowserView>

                {isInAboutPanel ||
                    isInInvestorsPanel ||
                    isInPrivacyPanel ||
                    isInTacPanel ||
                    isInSettings ? (

                    <div className='topSubmenuBack'>
                        <button
                            className='topSubmenuBackButton'
                            onClick={backToMap}
                        >
                            Back to Map
                        </button>
                    </div>

                ) : (

                    <div>

                        <button
                            style={{
                                position: 'relative',
                                paddingTop: '10px',
                                paddingLeft: '20px',
                                left: '20px',
                                top: '8px',
                                paddingRight: '20px',
                                color: '#fff',
                                paddingBottom: '10px',
                                borderRadius: '3px',
                                zIndex: 10,
                                textAlign: 'center',
                                margin: '0px 10px',
                                backgroundColor: '#29645D',
                                cursor: 'pointer'
                            }}
                            onClick={() => setisMenuLoadClick(true)}
                        >
                            Load
                        </button>

                        <GenPDF
                            globalRefs={globalRefs}
                            globalState={globalState}
                        />

                        <button
                            style={{
                                position: 'relative',
                                paddingTop: '10px',
                                paddingLeft: '20px',
                                left: '50%',
                                top: '8px',
                                transform: 'translateX(-50%)',
                                paddingRight: '20px',
                                color: '#fff',
                                paddingBottom: '10px',
                                borderRadius: '3px',
                                zIndex: 10,
                                textAlign: 'center',
                                margin: '0px 10px',
                                backgroundColor: multuGroupSelectedArray.length > 0
                                    ? 'black'
                                    : '#E6E4ED',
                                cursor: multuGroupSelectedArray.length > 0
                                    ? 'pointer'
                                    : 'not-allowed',
                                pointerEvents: multuGroupSelectedArray.length > 0
                                    ? 'auto'
                                    : 'none',
                            }}
                            onClick={closeClickedInfoRealm}
                        >
                            Empty Selection
                        </button>

                        <SearchBar
                            mapboxTokenRef={mapboxTokenRef}
                            globalRefs={globalRefs}
                            globalState={globalState}
                        />

                    </div>
                )}

            </BrowserView>

        </div>
    );
};

export default TopSubMenu;
